function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { Tabs as BSTabs, Tab as BSTab } from 'react-bootstrap';
var Tabs = function(param) {
    var defaultActiveKey = param.defaultActiveKey, onSelect = param.onSelect, children = param.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: "Tabs"
    }, /*#__PURE__*/ React.createElement(BSTabs, _object_spread({
        defaultActiveKey: defaultActiveKey
    }, !!onSelect && {
        onSelect: onSelect
    }), children));
};
// This is a wrapper just in case we need to do changes later down the line
export var Tab = function(_param) {
    var children = _param.children, restProps = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(BSTab, restProps, children);
};
export default Tabs;
